/* eslint-disable sonarjs/no-duplicate-string */
import { Injectable, inject } from '@angular/core';
import { safelyCreateHttpParams } from './api/api-utils';
import { components, operations } from './api/generated/ix-api.types';
import { IxRestApi } from './api/ix-rest-api';

export type PropertyDefDto = components['schemas']['PropertyDefDto'];
export type PropertyDefDataType = PropertyDefDto['datatype'];
export type PropertyDefPropertyKind = PropertyDefDto['propertyKind'];
export type PropertyDefStatus = NonNullable<PropertyDefDto['status']>;
export type PropertyDefsDto = components['schemas']['PropertyDefsDto'];
export type PropertyChangeEventInputDto = components['schemas']['PropertyChangeEventInputDto'];
export type PropertyChangeEventOutputDto = components['schemas']['PropertyChangeEventOutputDto'];
export type PropertyDto = components['schemas']['PropertyDto'];
export type PropertyDefAdminDto = components['schemas']['PropertyDefAdminDto'];
export type PropertyErrorType = PropertyDto['errorType'];
export type ReasonForIssueOutputDto = components['schemas']['ReasonForIssueOutputDto'];

@Injectable({
  providedIn: 'root',
})
export class PropertyDefinitionsApiService {
  readonly #ixRestApi = inject(IxRestApi);

  getPropertyDefinitions(path: operations['getPropertyDefinitions']['parameters']['path']) {
    return this.#ixRestApi.get({
      pathname: '/api/projects/{projectId}/propertydefinitions',
      options: { path },
    });
  }

  getPropertyDefinitionsForView(
    path: operations['getPropertyDefinitionsForView']['parameters']['path'],
    query: operations['getPropertyDefinitionsForView']['parameters']['query'],
  ) {
    return this.#ixRestApi.get(
      {
        pathname: '/api/projects/{projectId}/view/{viewType}/propertydefinitions',
        options: { path },
      },
      { params: safelyCreateHttpParams(query) },
    );
  }

  createPropertyDefs(
    path: operations['createPropertyDefs']['parameters']['path'],
    query: operations['createPropertyDefs']['parameters']['query'],
  ) {
    return this.#ixRestApi.post(
      { pathname: '/api/projects/{projectId}/propertydefinitions', options: { path } },
      undefined,
      {
        params: safelyCreateHttpParams(query),
      },
    );
  }

  updatePropertyDefs(
    path: operations['updatePropertyDefs']['parameters']['path'],
    requestBody: operations['updatePropertyDefs']['requestBody']['content']['application/json'],
  ) {
    return this.#ixRestApi.put(
      { pathname: '/api/projects/{projectId}/propertydefinitions', options: { path } },
      requestBody,
    );
  }

  deletePropertyDef(path: operations['deletePropertyDef']['parameters']['path']) {
    return this.#ixRestApi.delete({
      pathname: '/api/projects/{projectId}/propertydefinitions/{propertyDefId}',
      options: { path },
    });
  }

  getReasonForIssues(path: operations['getReasonForIssues']['parameters']['path']) {
    return this.#ixRestApi.get({
      pathname: '/api/profiles/{profileKind}/{profileId}/reasonforissues',
      options: { path },
    });
  }
}
